import React from "react";

export default function Sparkline({ data = [], color, height = 40 }) {
  if (!data.length) return null;
  const w = 200, h = height;
  const values = data.map((d) => d.value ?? d.count ?? 0);
  const max    = Math.max(...values);
  const min    = Math.min(...values);
  const range  = max - min || 1;

  const pts = values.map((v, i) => {
    const x = (i / (values.length - 1)) * w;
    const y = h - ((v - min) / range) * (h - 4) - 2;
    return `${x},${y}`;
  });

  const [lastX, lastY] = pts[pts.length - 1].split(",");

  return (
    <svg width="100%" viewBox={`0 0 ${w} ${h}`} style={{ display: "block" }}>
      <polyline
        points={pts.join(" ")}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={lastX} cy={lastY} r="2.5" fill={color} />
    </svg>
  );
}